import { ReservationDataGrid } from "../../types/globalTypes"
import { getReservationContents } from "../../utils/apiUtils"

export default function ReservationTableCell({
  reservation,
}: ReservationDataGrid) {
  return getReservationContents(reservation.reservation)
}
